import * as React from "react"

const SvgBookmarks = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10 19.571-4.55 2.275a.95.95 0 0 1-.975-.037Q4 21.521 4 20.946V8.571q0-.825.588-1.412A1.93 1.93 0 0 1 6 6.57h8q.825 0 1.412.588Q16 7.745 16 8.57v12.375q0 .575-.475.863a.95.95 0 0 1-.975.037zm-4-.025 3.05-1.65a1.93 1.93 0 0 1 1.9 0l3.05 1.65V8.571H6zm13-.975a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-13H8a.97.97 0 0 1-.713-.287A.97.97 0 0 1 7 3.57a.97.97 0 0 1 .287-.712A.97.97 0 0 1 8 2.57h10q.824 0 1.413.588Q20 3.745 20 4.57v13a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287Z" />
  </svg>
)
export default SvgBookmarks
